module.exports = __webpack_public_path__ + "img/2.4b4c9d92.jpg";